import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserContext } from "../../utils/UserContext";
import { potAccedirAgenda } from "../../utils/Permisos";
import { API_URL } from "../../utils/config";
import { fetchAutenticat, SessioCaducadaError } from "../../utils/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import "./agendaglobus.css";

const INTERVAL_MS = 60000;

function AgendaGlobus() {
  const navigate = useNavigate();
  const location = useLocation();
  const { empresaSeleccionada, rolUsuari } = useUserContext();
  const [pendents, setPendents] = useState(0);

  const potVeureAgenda = potAccedirAgenda(rolUsuari);

  const fetchPendents = useCallback(async () => {
    if (!empresaSeleccionada?.IdEmpresa || !potVeureAgenda) {
      setPendents(0);
      return;
    }
    try {
      const resp = await fetchAutenticat(`${API_URL}/AgendaPendents.php`, {
        method: "POST",
        body: JSON.stringify({ idEmpresa: empresaSeleccionada.IdEmpresa }),
      });
      const data = await resp.json();
      setPendents(data.success ? Number(data.pendents) || 0 : 0);
    } catch (e) {
      if (e instanceof SessioCaducadaError) return;
      setPendents(0);
    }
  }, [empresaSeleccionada, potVeureAgenda]);

  useEffect(() => {
    fetchPendents();
    if (!potVeureAgenda || !empresaSeleccionada?.IdEmpresa) return undefined;

    const id = setInterval(fetchPendents, INTERVAL_MS);
    const onFocus = () => fetchPendents();
    window.addEventListener("focus", onFocus);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
    };
  }, [fetchPendents, potVeureAgenda, empresaSeleccionada, location.pathname]);

  if (!potVeureAgenda || !empresaSeleccionada) return null;

  const etiqueta = pendents > 99 ? "99+" : String(pendents);
  const title = pendents === 1
    ? "1 pendent a l'Agenda"
    : `${pendents} pendents a l'Agenda`;

  return (
    <button
      className="dv2-nav-icon agenda-globus"
      onClick={() => navigate("/dashboard/agenda")}
      type="button"
      title={title}
      aria-label={title}
    >
      <FontAwesomeIcon icon={faBell} />
      {pendents > 0 && <span className="agenda-globus-badge">{etiqueta}</span>}
    </button>
  );
}

export default AgendaGlobus;
